export enum TypeProprieteEnum {
  Maison = 'maison',
  Multiplex = 'multiplex',
  Autre = 'autre'
}
